import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Analyses of spatio temporal LU changes for Karnataka highlights
              the loss of forest cover and conversion of agriculture to other
              use due to anthropogenic pressures. The evergreen forest cover has
              reduced from 4.2% (1985) to 3% (2018) with the increase in
              plantations, built-up areas. The new urban agglomerations were
              noticed across the cities and major towns such as Bengaluru,
              Mangalore, Hubli, Hassan, Mysore etc. The total forest cover loss
              was accounted to be 6.2%, where as non-forest over has increased
              by 5.7%. The major tracts of deciduous forests were replaced by
              anthropogenic as evident from 1985 to 2018. Due to large scale
              plantations of Eucalyptus, Rubber, Acacia, teak and Arecanut have
              increased from 1985 to 2018 covering 19.45% of the state. Due to
              increase in horticulture plantations and increase in paved
              surfaces croplands have decreased from 68% (1985) to 64.09%
              (2018). These changes are abrupt and resulting in imbalance of
              ecosystem services, hydrology, and natural resources availability.
              The temporal LST results further highlights the loss of forest
              cover has resulted in increase in temperature gradient across the
              state. The higher temperature can be seen especially in non-forest
              areas due to intensified built-up activities. The rise in
              temperature can be attributed to high deforestation with unplanned
              urbanisation and industrialisation. Table 1 illustrates
              temperature gradient across the agro climatic zones. Urban areas
              show increase in temperature (maximum) as population explosion
              exerts pressure on the local resources such as open lands and
              forest cover. Temporal analysis of LST indicates rise in mean
              temperature over the periods. The highest temperature of 48.46˚C
              was found in the hot dry semi-arid region and the lowest was found
              in hot humid of 32.46 ˚C.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ldk3.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 3. LU analysis of Karnataka from 1985 to 2018
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ldk4.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 4. LST dynamics of Karnataka from 2006 to 2018 Table 1. LST
              across the agro climatic zones
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="176">
                    <p>&nbsp;</p>
                    <p>
                      <strong>Regions</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="151">
                    <p>
                      <strong>2006</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="151">
                    <p>
                      <strong>2012</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="152">
                    <p>
                      <strong>2018</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="74">
                    <p>
                      <strong>Min (˚C)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>
                      <strong>Max (˚C)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>
                      <strong>Min (˚C)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>
                      <strong>Max (˚C)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>
                      <strong>Min (˚C)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>
                      <strong>Max (˚C)</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Hot dry semi-arid (1)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>38.55</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>41.92</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>40.35</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>43.5</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>43.27</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>48.46</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Arid (2)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>33.57</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>38.08</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>29.39</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>33.88</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>37.21</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>41.25</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Hot moist semi-arid (3)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>26.91</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>41.58</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>26.49</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>38.7</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>28.78</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>44.57</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Hot moist sub humid (4)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>22.85</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>32.38</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>21.53</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>27.3</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>27.11</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>38.31</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Hot humid (5)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>26.83</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>29.9</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>25.77</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>28.9</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>29.89</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>32.46</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="176">
                    <p>Hot dry sub humid (6)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>32.49</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>35.92</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>29.33</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>39.08</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>38.11</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>45.68</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <em>
                Where Tsmin = Satellite minimum temperature, Tsmax = Satellite
                maximum temperature, Tsmean = Satellite mean temperature, Tgmin
                = Ground minimum temperature, Tgmax = Ground maximum temperature
                Tgmean = Ground mean temperature
              </em>
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ldk5.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 5. LST across agro climatic zones from 2006-2018.
            </p>
            <p>&nbsp;</p>
            <p>
              Figure 5 confirms that LST (satellite temperature) are comparable
              to ground measurement across the agro climatic zones. Ground air
              temperature was measured at a distance of 2 m above ground while
              satellite gives temperature of land surface which may be 2-3 ˚C
              higher. The 1km gradient has been used for sampling across the
              agro climatic zones from forest and non-forest categories to
              assess the temperature variations across the LU. The two samples
              were taken for each agro climatic zone except Hot Moist semi-arid
              (4 samples) due to larger coverage. The correlation analysis shows
              (Figure 6) forest decreases on increase in temperature indicating
              indirect relationship. This indicates forest holds strong
              co-relationship of 0.8 (r=0.94) with temperature. Whereas, it was
              observed that on increase built-up areas, temperature goes up
              which shows direct relationship. Also, non-forest cover holds a
              strong co-relationship of 0.5 (r=0.74) with temperature. The
              gradients depict as non-forest cover has increased in the region
              depicted rise in temperature. The results highlight the role of
              bio-physical variables in maintaining regional climate. The
              increase in temperature can induce higher loss of species,
              imbalance in ecosystem, vegetation die- off. It is suggested to
              curb the unplanned developments and increase in forest cover with
              native species through stakeholder&rsquo;s active involvement
              would help in the conservation and prevent further degradation of
              landscape. The effective forest management with forest
              regeneration activities would help in reducing LST and its ill
              effects.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ldk6.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 6. Correlation among forest, non-forest LU with LST
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
